import '../styles/Card.css';

const Card = ({ title, color, image, link, description }) => {
  return (
    <div className="overlay">
      <div className="card">
        <div className="card-header" style={{ backgroundColor: color }} >
          <h2>{title}</h2>
        </div>
        <div className="card-body">
          <img src={require(`../assets/imagenes/ods/${image}`)} alt="ods-1" />
          <p>{description}</p>
          <div id="more-info">
            <a className="custom-link" href={link} target="_blank">Más información ➜</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;